module.exports = __webpack_public_path__ + "img/tableYeti-wide-logo.13c06637.png";